import { Middleware, AnyAction } from '@reduxjs/toolkit';
import { selectSaveViewsFunction } from '../saveViewsActionSlice';
import { selectViews } from '../viewsSlice';

// Actions that modify views
const VIEW_MODIFICATION_ACTIONS = [
  'views/addRootView',
  'views/addChildView',
  'views/removeView',
  'views/updateView',
  'views/duplicateView',
  'views/moveView'
];

let saveTimeout: NodeJS.Timeout | null = null;

export const viewPersistenceMiddleware: Middleware = ( store ) => ( next ) => ( action: AnyAction ) => {
  const result = next( action );

  // Check if this is a view modification action
  if ( action.type && VIEW_MODIFICATION_ACTIONS.includes( action.type )) {
    // Clear existing timeout
    if ( saveTimeout ) {
      clearTimeout( saveTimeout );
    }

    // Debounce save by 1500ms
    saveTimeout = setTimeout(() => {
      const state = store.getState();
      const saveViewsFunction = selectSaveViewsFunction( state );
      const currentViews = selectViews( state );

      // Call save function if it exists
      if ( saveViewsFunction && currentViews ) {
        saveViewsFunction( currentViews ).catch(( error ) => {
          // Throw error to global error handler
          throw error;
        });
      }
    }, 1500 );
  }

  return result;
};
